import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Identificador en monoespaciada: IMEI, codigo de producto, numero de orden,
 * remito, cheque. Es el UNICO lugar (junto con `kbd`) donde el feature obtiene
 * `font-mono`: la plata va en Inter tabular via <Importe>, nunca aca.
 *
 * Un IMEI de 15 digitos si se beneficia de la mono: se cuenta de a grupos y se
 * compara caracter a caracter con el papel.
 */
export function Codigo({ className, ...props }: HTMLAttributes<HTMLSpanElement>): JSX.Element {
  return <span className={cn("font-mono tabular-nums tracking-tight", className)} {...props} />;
}
